import axios, { type AxiosInstance, type AxiosRequestConfig } from 'axios'
import { config } from '@/config'

// Create axios instance with default config
export const apiClient: AxiosInstance = axios.create({
  baseURL: config.apiBaseURL,
  withCredentials: true, // This is critical for sending cookies cross-origin
  headers: {
    'Content-Type': 'application/json'
  },
  // Ensure credentials are sent with all requests
  xsrfCookieName: 'schoolbus.sid',
  xsrfHeaderName: 'X-CSRF-Token'
})

// Request interceptor
apiClient.interceptors.request.use(
  (config) => {
    // Ensure withCredentials is always true for cookies
    config.withCredentials = true
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Response interceptor
apiClient.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    // Don't auto-redirect on 401 - let components handle it
    // This prevents redirect loops during login
    return Promise.reject(error)
  }
)

// Helper function for API calls
export async function apiRequest<T>(
  config: AxiosRequestConfig
): Promise<T> {
  try {
    const response = await apiClient.request<T>(config)
    return response.data
  } catch (error) {
    throw error
  }
}

